export default __webpack_public_path__ + "static/chart-illustration-18888a3fca5979aba817b92bdc3bfab6.svg";